import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import pluralize from 'pluralize';
import styled from 'styled-components';
import { ProductType, CartItemType } from 'types';
import { Container, FormattedPrice, Button } from 'components/shared';
import { getCartCurrency, getCartItems } from 'ducks/cart';
import { theme, media } from 'styles';
import RecurringToggle from './RecurringToggle';
import QuantitySelector from './QuantitySelector';

const initialState = {
  quantity: 1,
  isLoading: false,
  isSuccess: false,
  recurring: true,
  months: 1,
};

const calculateItemPrice = (price, quantity, months) => {
  if (months === 1) {
    return price * quantity;
  }
  const subtotal = price * quantity * months;
  return subtotal;
};

const StyledRecurringToggle = styled(RecurringToggle)``;

const StyledAddToCart = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 18px 0px;
`;

const Left = styled.div`
  font-size: 16px;
  display: none;
  ${media.tablet`display:block;`};
`;

const Right = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 90px;
  justify-content: space-between;
  ${media.tablet`
    flex-direction: row;
    height: inherit;
    width: inherit;
  `};
`;
const Toggles = styled.div`
  display: flex;
  justify-content: space-between;
`;
const Name = styled.div`
  color: ${theme.colors.white};
`;

const Price = styled.div`
  color: ${theme.colors.blue};
`;

const StyledCTA = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
`;

class AddToCart extends React.Component {
  static propTypes = {
    product: ProductType.isRequired,
    onAddToCart: PropTypes.func.isRequired,
    afterAddToCart: PropTypes.func,
    currency: PropTypes.string.isRequired,
    cartItems: PropTypes.arrayOf(CartItemType).isRequired,
  };

  static defaultProps = {
    afterAddToCart: () => {},
  };

  constructor(props) {
    super(props);
    this.state = initialState;
    this.onAddToCart = this.onAddToCart.bind(this);
    this.getQuantityVariable = this.getQuantityVariable.bind(this);
  }

  async onAddToCart() {
    const { quantity, months, recurring } = this.state;
    const { product } = this.props;
    const actuallyRecurring = recurring && product.allowRecurringPurchase;
    await this.props.onAddToCart(quantity, months, actuallyRecurring);
    this.setState({ isSuccess: true, isLoading: false });
    this.props.afterAddToCart();
    setTimeout(() => this.setState(initialState), 3000);
  }

  getQuantityVariable() {
    const { product } = this.props;
    if (this.state.quantity === 1) return product.quantityVariable;

    return product.quantityVariablePlural
      ? product.quantityVariablePlural
      : pluralize(product.quantityVariable);
  }

  inCart(product) {
    return this.props.cartItems.some(
      el => el.sellableId === parseInt(product.id, 10),
    );
  }

  render() {
    const { product, currency } = this.props;
    const { isLoading, isSuccess, quantity, recurring, months } = this.state;
    const finalPrice = calculateItemPrice(
      product.prices[currency].price,
      quantity,
      months,
    );
    const quantityVariable = this.getQuantityVariable();

    return (
      <Container>
        <StyledAddToCart className="AddToCart">
          <Left>
            <Name>{product.name}</Name>
            <Price>
              <FormattedPrice quantity={1} unitPrice={finalPrice} />
            </Price>
          </Left>
          <Right>
            {product.allowRecurringPurchase && (
              <StyledRecurringToggle
                dark
                recurring={recurring}
                onChange={() =>
                  this.setState({ recurring: !recurring, months: 1 })
                }
              />
            )}
            <Toggles>
              {product.allowMultiplePurchase && (
                <QuantitySelector
                  quantity={quantity}
                  quantityVariable={quantityVariable}
                  onChange={change =>
                    this.setState({ quantity: quantity + change })
                  }
                />
              )}
              <StyledCTA>
                <Button
                  block
                  blue
                  green={isSuccess}
                  disabled={isSuccess}
                  isLoading={isLoading}
                  onClick={this.onAddToCart}
                  data-test-id="add-to-cart-button"
                >
                  {!isLoading &&
                    (this.inCart(product) ? 'Added to Cart' : 'Add To Cart')}
                </Button>
              </StyledCTA>
            </Toggles>
          </Right>
        </StyledAddToCart>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  currency: getCartCurrency(state),
  cartItems: getCartItems(state),
});

export default connect(mapStateToProps)(AddToCart);



// WEBPACK FOOTER //
// ./src/components/shared/AddToCart/AddToCart.jsx